import { autoserializeAs } from 'cerialize';

import { DriverDocument } from './driver-document';
import { Driver } from './driver';

export class DocumentReviewItem {
  @autoserializeAs(DriverDocument)
  documents: Array<DriverDocument>;

  @autoserializeAs(Driver)
  driver: Driver;
}
